import resources from '../../resources'

import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  mixins: [resources],
  methods,
  mounted
}



// WEBPACK FOOTER //
// ./src/crud/index/resources/index.js